// Loaded once per page load - registers <temba-simulator>, <temba-flow-editor> (and everything else in
// temba-modules.ts) as real custom elements, as a side effect of evaluating the module. Shared by every
// component that needs a temba-components-aspin custom element, so there's only one cache-busting version
// to bump (and only one network fetch) no matter how many of these widgets a page uses.
//
// Cache-busted with a build-time marker (bump this string whenever the vendor bundle is rebuilt while
// testing locally) - this file is repeatedly overwritten at the same /vendor/temba-components.js URL
// during local development, and browsers cache JS aggressively, so without this a hard refresh wouldn't
// reliably pick up a fresh build.
const VENDOR_BUNDLE_VERSION = '2026-07-24-01'
let vendorBundleLoaded = null
export function loadVendorBundle() {
  if (!vendorBundleLoaded) {
    // temba-icon (used throughout the simulator's own internal toolbar - context explorer, language,
    // back, close) builds its href as `${window.static_url || '/static/'}svg/index.svg#<name>`, since in
    // RapidPro's own Django app that sprite sheet is served from /static/. Webclient has no /static/ of
    // its own, so left at the default every icon silently resolved to nothing and rendered blank. Must be
    // set before the bundle evaluates, since components read it once at render time.
    window.static_url = '/vendor/'
    vendorBundleLoaded = import(
      /* webpackIgnore: true */ `/vendor/temba-components.js?v=${VENDOR_BUNDLE_VERSION}`
    )
  }
  return vendorBundleLoaded
}
